import React, { useEffect } from 'react';
import { SaveOutlined } from '@ant-design/icons';
import apiConfig from '@constants/apiConfig';
import { doneType } from '@constants/masterData';
import useAuth from '@hooks/useAuth';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, NumericField, SelectField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { validatePermission } from '@utils';
import { Button, Col, Flex, Form, Row, Switch } from 'antd';

const PickupSettingForm = ({ formId, actions, dataDetail, onSubmit, isChanged, setIsChangedFormValues, isEditing, loading }) => {
    const translate = useTranslate();
    const doneTypeValues = translate.formatKeys(doneType, ['label']);
    const { permissions } = useAuth();

    const hasPermission = validatePermission([apiConfig.kitplayDevice.updateSettings.baseURL], permissions);

    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const handleSubmit = (values) => {
        let currentSettings = {};
        try {
            currentSettings = dataDetail?.settings ? JSON.parse(dataDetail.settings) : {};
        } catch {
            currentSettings = {};
        }

        const finalValues = {
            // ...values,
            settings: JSON.stringify({
                kitplay: {
                    time_delete_archive_order: values.timeDeleteArchiveOrder ? Number(values.timeDeleteArchiveOrder) : null,
                    done_type: values.doneType ? Number(values.doneType) : null,
                    push_to_mpos: values.pushToMpos ? true : false,
                },
                pickup_display: currentSettings.pickup_display ?? {},
            }),
        };

        return mixinFuncs.handleSubmit(finalValues);
    };

    useEffect(() => {
        if (dataDetail && isEditing) {
            let parsedSettings = {};
            try {
                parsedSettings = dataDetail.settings ? JSON.parse(dataDetail.settings) : {};
            } catch {
                parsedSettings = {};
            }

            const kitplay = parsedSettings.kitplay ?? {};

            form.setFieldsValue({
                ...dataDetail,
                timeDeleteArchiveOrder: kitplay.time_delete_archive_order ?? null,
                doneType: kitplay.done_type ?? null,
                pushToMpos: kitplay.push_to_mpos ?? false,
            });
        } else {
            form.setFieldsValue({
                pushToMpos: false,
            });
        }
    }, [dataDetail, isEditing]);

    return (
        <BaseForm id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <div style={{ paddingTop: 16 }}>
                <Row gutter={16}>
                    
                </Row>
                {/* {hasPermission && (
                    <div className="footer-card-form">
                        <Flex justify="end" gap={16}>
                            <Button htmlType="submit" type="primary" loading={loading} icon={<SaveOutlined />} disabled={!isChanged}>
                                {translate.formatMessage(commonMessage.update)}
                            </Button>
                        </Flex>
                    </div>
                )}  */}
            </div>
        </BaseForm>
    );
};

export default PickupSettingForm;
